import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { TeamEvent } from '../models/team-event';
import { TeamEventInvite } from '../models/team-event-invite';
import { ConfigService } from '../services/config.service';

@Injectable({providedIn: 'root'})
export class TeamEventApi {
  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {}

  async getTeamEvent(teamEventId: number): Promise<TeamEvent> {
    return this.httpClient
      .get(`${this.configService.get('apiUrl')}/api/v1/team_event/${teamEventId}/`)
      .pipe(map(data => TeamEvent.toFront(data)))
      .toPromise();
  }

  async updateTeamEvent(teamEvent: TeamEvent): Promise<TeamEvent> {
    return this.httpClient
      .patch(`${this.configService.get('apiUrl')}/api/v1/team_event/${teamEvent.id}/`, TeamEvent.toBack(teamEvent))
      .pipe(map(data => TeamEvent.toFront(data)))
      .toPromise();
  }

  async deleteTeamEvent(teamEventId: number): Promise<any> {
    return this.httpClient
      .delete(`${this.configService.get('apiUrl')}/api/v1/team_event/${teamEventId}/`)
      .toPromise();
  }

  async getTeamEventInvites(teamEventId: number): Promise<TeamEventInvite[]> {
    return this.httpClient
      .get(`${this.configService.get('apiUrl')}/api/v1/team_event/${teamEventId}/invites/`)
      .pipe(map(data => TeamEventInvite.toFront(data)))
      .toPromise();
  }

  async createTeamEventInvite(teamEventId: number, teamUserId: number): Promise<TeamEventInvite> {
    return this.httpClient
      .post(`${this.configService.get('apiUrl')}/api/v1/team_event/${teamEventId}/invites/`, {team_user_id: teamUserId})
      .pipe(map(data => TeamEventInvite.toFront(data)))
      .toPromise();
  }

  async acceptTeamEventInvite(teamEventInvite: TeamEventInvite): Promise<TeamEventInvite> {
    return this.httpClient
      .post(`${this.configService.get('apiUrl')}/api/v1/team_event_invite/${teamEventInvite.id}/accept/`, {})
      .pipe(map(data => TeamEventInvite.toFront(data)))
      .toPromise();
  }

  async declineTeamEventInvite(teamEventInvite: TeamEventInvite): Promise<TeamEventInvite> {
    return this.httpClient
      .post(`${this.configService.get('apiUrl')}/api/v1/team_event_invite/${teamEventInvite.id}/decline/`, {})
      .pipe(map(data => TeamEventInvite.toFront(data)))
      .toPromise();
  }
}
